import { Settings } from '@/features/shared/models/Settings';

export const ISettingsApiId = Symbol.for('ISettingsApi');

export interface ISettingsApi {
    /**
     * Fetch settings
     */
    getSettings(): Promise<Settings>;
}
